import { Outlet } from "react-router-dom";
import FooterBloc from "../blocs/common/FooterBloc";
import HeaderBloc from "../blocs/common/HeaderBloc";
import SidePannelBloc from "../blocs/common/SidePannelBloc";
import { MAX_MOBILE_WIDTH } from "../const/AppConst";
import useWindowDimensions from "../hooks/useWindowDimensions";
import useAppState from "../context/AppContext";
import RESidePannelRetirementBloc from "../blocs/retirement/RESidePannelRetirementBloc";

export default function BaseLayoutPage() {
  const {
    state: { isRetired },
  } = useAppState();
  const {width} = useWindowDimensions();
  const isMobile = width <= MAX_MOBILE_WIDTH;  
  return (
      <>
        <section id='page-entreprise' className='page-entreprise'>
          <HeaderBloc/>
          {!isMobile&& !isRetired && <SidePannelBloc/>}
          {!isMobile&& isRetired && <RESidePannelRetirementBloc/>}
          <main className="entreprise-main bg-glace">
            <Outlet />
          </main>
          
        </section>
        <FooterBloc/>
      </>
  )
}